import type {CTABannerKey} from 'nutshell-graphql-types';
import type {CTABanner, CTABanner_demioEvent as DemioEvent} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../../analytics-client';
import type {AnalyticsConstant} from '../../../../analytics-client';

// Type to appease flow, we know demioBanner events will have a demioEvent
type DemioBanner = CTABanner & {
    demioEvent: DemioEvent;
};

type ImageInfo = {
    src: string;
    width: number;
};

export const getNonDemioBanners = (banners: CTABanner[]): CTABanner[] => {
    return banners.filter((banner) => banner.ctaType !== 'DEMIO');
};

export const getDemioBanners = (banners: CTABanner[]): DemioBanner[] => {
    // @ts-expect-error
    return banners.filter((banner) => banner.ctaType === 'DEMIO' && banner.demioEvent);
};

export const getRegistrationUrlFromCTABanner = (
    banner: CTABanner
): {
    href: string;
    isRoutedLink?: boolean;
} => {
    // Incase the registration url is not set for some reason, default to Jared's 15 minute meeting
    const registrationUrl =
        banner && banner.registrationUrl
            ? banner.registrationUrl
            : 'https://nut.sh/ell/schedule-booking/4/HYBCmL';

    switch (banner.key) {
        case 'IMPORT':
            return {href: '/setup/import/white-glove', isRoutedLink: true};
        default:
            return {href: registrationUrl};
    }
};

export const getImageInfoFromCTAKey = (key: CTABannerKey): ImageInfo => {
    switch (key) {
        case 'IMPORT':
            return {
                src: '/include/images/import-data.png',
                width: 60,
            };
        case 'MEET_WITH_TEAM_JARED':
            return {
                src: '/include/images/portraits/jared.jpg',
                width: 60,
            };
        case 'MEET_WITH_TEAM_CHAD':
            return {
                src: '/include/images/portraits/chad.jpg',
                width: 60,
            };
        case 'LEARN_BASICS':
            return {src: '/include/images/portraits/tonya.png', width: 60};
        case 'SALES_TRAINING':
            return {src: '/include/images/portraits/nutshell-basics-team.jpg', width: 60}; // UPDATE WITH NEW PNG
        case 'LIVE_DEMO':
        default:
            return {
                src: '/include/images/portraits/webcast-team.svg',
                width: 120,
            };
    }
};

export const getButtonTextFromCTAKey = (key: CTABannerKey): string => {
    switch (key) {
        case 'IMPORT':
            return 'Upload data';
        case 'MEET_WITH_TEAM_JARED':
            return 'Book with Jared';
        case 'MEET_WITH_TEAM_CHAD':
            return 'Book with Chad';
        default:
            return '';
    }
};

export const getAnalyticsEventNameFromCTAKey = (
    key: CTABannerKey
): AnalyticsConstant | null | undefined => {
    switch (key) {
        case 'IMPORT':
            return analyticsClient.EVENTS.TRACK_CTA_BANNER_IMPORT_CLICKED;
        case 'MEET_WITH_TEAM_JARED':
        case 'MEET_WITH_TEAM_CHAD':
            return analyticsClient.EVENTS.TRACK_CTA_SALES_BOOKING_CLICKED;
        default:
            return null;
    }
};
